import axios, { AxiosHeaders } from 'axios';
const dataFetcher = (url, data, authToken, withCredentials = true) => {
    const headers = new AxiosHeaders();
    if (authToken) {
        headers.set('Authorization', `Bearer ${authToken}`);
    }
    return axios({
        url,
        data,
        method: data ? 'POST' : 'GET',
        // note: axios needs to use `withCredentials: true` in order for
        // Sitecore cookies to be included in CORS requests
        // which is necessary for analytics and such
        withCredentials,
        headers,
    });
};
export default dataFetcher;
